import React, { useState } from 'react';
import { submitReport } from '../api/AdminApi';
import '../Style/ReportModal.css';

const REASONS = [
  { value: 'SPAM', label: '🚫 Spam' },
  { value: 'INAPPROPRIATE_CONTENT', label: '⚠️ Inappropriate Content' },
  { value: 'HARASSMENT', label: '😤 Harassment' },
  { value: 'FAKE_ACCOUNT', label: '🎭 Fake Account' },
  { value: 'OTHER', label: '📝 Other' },
];

const ReportModal = ({ reportedId, reportedName, onClose }) => {
  const [reason, setReason] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    if (!reason) {
      setError('Please select a reason.');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await submitReport(reportedId, reason, message || null);
      setSubmitted(true);
    } catch (err) {
      if (err.response?.status === 409) {
        setError('You have already reported this user.');
      } else {
        setError('Failed to submit report. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="report-modal-overlay" onClick={onClose}>
      <div className="report-modal-card" onClick={(e) => e.stopPropagation()}>
        {submitted ? (
          <div className="report-success">
            <span className="report-success-icon">✅</span>
            <h3>Report Submitted</h3>
            <p>Thank you. We'll review this report shortly.</p>
            <button className="report-close-btn" onClick={onClose}>
              Close
            </button>
          </div>
        ) : (
          <>
            <div className="report-modal-header">
              <h3>Report {reportedName}</h3>
              <button className="report-x-btn" onClick={onClose}>
                ×
              </button>
            </div>

            <p className="report-modal-subtitle">
              Help us understand what's wrong with this account.
            </p>

            <div className="report-reasons">
              {REASONS.map((r) => (
                <label
                  key={r.value}
                  className={`report-reason-item ${reason === r.value ? 'selected' : ''}`}
                >
                  <input
                    type="radio"
                    name="reason"
                    value={r.value}
                    checked={reason === r.value}
                    onChange={() => setReason(r.value)}
                  />
                  <span>{r.label}</span>
                </label>
              ))}
            </div>

            <textarea
              className="report-message-input"
              rows={3}
              maxLength={500}
              placeholder="Additional details (optional)..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <span className="report-char-count">{message.length}/500</span>

            {error && <p className="report-error">{error}</p>}

            <button className="report-submit-btn" onClick={handleSubmit} disabled={loading}>
              {loading ? 'Submitting...' : 'Submit Report'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ReportModal;
